import React from 'react';
import {cn} from '@/utils';

interface SectionWrapperProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({
  title,
  children,
  className,
}) => {
  return (
    <div className={cn('bg-white rounded-lg p-3', className)}>
      {/* 标题区域 */}
      <div className="flex items-start gap-2 mb-3">
        <div className="bg-c1 h-[1.125rem] w-[0.1875rem] flex-shrink-0" />
        <h2 className="text-base font-semibold text-black leading-none">
          {title}
        </h2>
      </div>

      {/* 内容区域 */}
      <div className="space-y-3">{children}</div>
    </div>
  );
};

export default SectionWrapper;
